import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor() {}

  notifyError(message: string, title?: string): void {
    Swal.fire({
      icon: 'error',
      title: title ? title : 'Error',
      text: message,
      confirmButtonText: 'Regresar al formulario',
      confirmButtonColor: '#E95A1A',
      customClass: {
        confirmButton: 'swal-button-outline',
      },
    });
  }

  showSuccessAlertAndAction(msg: string, ejecutar: any) {
    Swal.fire({
      title: 'Éxito',
      text: msg,
      icon: 'success',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
    }).then((result) => {
      if (result.isConfirmed) {
        ejecutar();
      }
    });
  }

  showSuccessAlertAndDoubleAction(msg: string, ejecutar: any, cancelar?: any) {
    Swal.fire({
      title: 'Éxito',
      text: msg,
      icon: 'success',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        ejecutar();
      } else if (result.dismiss === Swal.DismissReason.cancel && cancelar) {
        cancelar();
      }
    });
  }

  showSuccessAlert(msg: string, ejecutar?: any) {
    if (ejecutar) {
      Swal.fire({
        title: 'Éxito',
        text: msg,
        icon: 'success',
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
      }).then(() => {
        ejecutar();
      });
    } else {
      Swal.fire({
        title: 'Éxito',
        text: msg,
        icon: 'success',
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
      });
    }
  }

  notifyWarning(message: string) {
    Swal.fire({
      icon: 'warning',
      title: 'Advertencia',
      text: message,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#E95A1A',
    });
  }

  showSuccessAlertPersonalizado(title: string, msg: string) {
    Swal.fire({
      title: title,
      text: msg,
      icon: 'success',
      showConfirmButton: false,
      timer: 1200,
      width: '512px',
      padding: '30px',
      customClass: {
        popup: 'my-swal-popup',
      },
    });
  }

  showErrorssAlertPersonalizado(title: string, msg: string) {
    Swal.fire({
      title: title,
      text: msg,
      icon: 'error',
      showConfirmButton: false,
      width: '512px',
      padding: '30px',
      customClass: {
        popup: 'my-swal-popup',
      },
    });
  }

  showSuccessAlertPersonalizadoAndAction(
    title: string,
    msg: string,
    ejecutar: any
  ) {
    Swal.fire({
      title: title,
      text: msg,
      icon: 'success',
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#d65730ff',
      width: '512px',
      padding: '30px',
      customClass: {
        popup: 'my-swal-popup',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        ejecutar();
      }
      if (result.isDismissed) {
        ejecutar();
      }
    });
  }

  showErrorssAlertPersonalizadoAndAction(
    title: string,
    msg: string,
    ejecutar: any
  ) {
    Swal.fire({
      title: title,
      text: msg,
      icon: 'error',
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#d65730ff',
      width: '512px',
      padding: '30px',
      customClass: {
        popup: 'my-swal-popup',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        ejecutar();
      }

      if (result.isDismissed) {
        ejecutar();
      }
    });
  }

  handleTimer(msg: string) {
    return msg?.length * 25;
  }
}
